import { Injectable, inject } from '@angular/core';
import { PreloaderServiceBase } from '@seahorse/common';
import { ProxyService } from '@seahorse/domain';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PreloaderService extends PreloaderServiceBase {
  private _proxyService = inject(ProxyService);

  preload(): Observable<boolean> {
    return this._proxyService.getData();
  }
}
